// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // 英文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import axios from 'axios'
import store from './store/store'
import VueLazyload from 'vue-lazyload'   //懒加载

// 移动端miniUI 框架
// import MintUI from 'mint-ui'
// import 'mint-ui/lib/style.css'
import 'swiper/dist/css/swiper.css';

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
Vue.prototype.$axios=axios

Vue.config.productionTip = false
Vue.prototype.$config = {
  imgUrl:'http://image.diartop.net/'
}
// const originalPush = router.prototype.push;
// router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
axios.defaults.headers.common['Authentication-Token'] = store.state.token;

// Vue.use(MintUI)
Vue.use(ElementUI, { zhLocale })
Vue.use(VueLazyload)

router.afterEach((to,from,next) => {

  window.scrollTo(0,0);

})

// 頁面加載判斷返回頁面值，記錄body.Scrolltop
router.beforeEach((to, from, next) => {
  let position =document.documentElement.scrollTop
    if(to.name=='kinds_detail' || to.name=='dapaiList'  || to.name=='pTdetail'  || to.name=='dinghuoList'  || to.name=='maggzine_detail' || to.name=='maggzine_info' || to.name=='maggzine_history' || to.name=='inter898-list' || to.name=='qushiDetail' || to.name=='t_detail' || to.name=='tTai_detail'  || to.name=='video_detail'){

      from.meta.savedPosition = document.documentElement.scrollTop
    }
    // this.$store.commit('SAVE_POSITION', position) //离开路由时把位置存起来
    next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js